import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../configuration'

export const addIncidentConfig: AddIncidentConfig<BasketballIncidentId> = {
  scoreIncidents: [
    BasketballIncidentId.FourPointShotMade,
    BasketballIncidentId.ThreePointShotMade,
    BasketballIncidentId.TwoPointShotMade,
    BasketballIncidentId.FreeThrowIn,
  ],
  missedIncidents: [
    BasketballIncidentId.FourPointShotMissed,
    BasketballIncidentId.ThreePointShotMissed,
    BasketballIncidentId.TwoPointShotMissed,
    BasketballIncidentId.FreeThrowMissed,
  ],
  stoppedIncidents: [BasketballIncidentId.OffensiveRebound],
  highlightedIncidents: [BasketballIncidentId.DefensiveRebound],
}
